import type { Theme } from '@mui/material';

import type { Translate } from '@shared/hooks/locale';

export type HealthTone = 'healthy' | 'fair' | 'atRisk' | 'neutral';

export const getHealthTone = (score: number): HealthTone => {
  if (score >= 80) {
    return 'healthy';
  }
  if (score >= 50) {
    return 'fair';
  }
  return 'atRisk';
};

export const getHealthLabel = (score: number, t: Translate): string => {
  if (score >= 80) {
    return t('Healthy');
  }
  if (score >= 50) {
    return t('Fair');
  }
  return t('At risk');
};

export const getHealthMainColor = (theme: Theme, tone: HealthTone): string => {
  switch (tone) {
    case 'healthy':
      return theme.palette.success.main;
    case 'fair':
      return theme.palette.warning.main;
    case 'atRisk':
      return theme.palette.error.main;
    case 'neutral':
    default:
      return theme.palette.text.disabled;
  }
};
